export default class FormSubmitButtonHandler {
    public static handle(form: HTMLFormElement): void {
        const buttons = Array.from(
            form.querySelectorAll('button[type="submit"]')
        ) as HTMLButtonElement[];

        if (!buttons.length) {
            return;
        }

        form.addEventListener('submit', () => {
            buttons.forEach((button) => {
                button.disabled = true;
            });
        });
    }
}
